export default __webpack_public_path__ + "static/media/mg-icon-active.763f0b2e.svg";